import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { ColorTable, Part } from '@usimweb/core/models';
import { C3Service, ug, Color3 } from '@usimweb/ceetron';

export interface PartsCustomInfo {
  partName: string;
  partId: number;
  temperature: number;
  material: string;
  walletThickness: number;
}

@Injectable({
  providedIn: 'root',
})
export class BoundingBoxService {
  public partsCustomInfo: PartsCustomInfo[] = [];
  public partsListener: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private c3Service: C3Service) {}

  public getParts(modelId: number) {
    return this.c3Service._model[modelId.toString()].modelDirectory.partInfoArray;
  }

  public getPartAt(id: number, modelId: number): boolean {
    let partInfoArray = this.c3Service._model[modelId.toString()].modelDirectory.partInfoArray;
    let currentPart: boolean = false;

    partInfoArray.forEach((element: ug.PartInfo) => {
      if (id == element.partId) {
        currentPart = element.boundaryCondition;
      }
    });

    return currentPart;
  }

  public setParts(modelId: number) {
    const parts = this.c3Service._model[modelId.toString()].modelDirectory.partInfoArray;
    const boundaryParts = parts.filter((part: Part) => part.boundaryCondition === true);
    this.partsListener.next(boundaryParts);
  }

  public colorizeParts(modelId: number) {
    let colorIndex = 0;
    for (let i = 0; i < this.c3Service._model[modelId.toString()].partCount; ++i) {
      let partSettings = this.c3Service._model[modelId.toString()].getPartSettingsAt(i);

      const boundaryCondition = this.getPartAt(partSettings.partId, 2);

      if (boundaryCondition) {
        partSettings.drawStyle = ug.DrawStyle.SURFACE;
        partSettings.opacity = 1;
        partSettings.visible = true;

        if (i > ColorTable.colorIndex()) {
          partSettings.color = new Color3(1, 1, 1);
        } else {
          partSettings.color = new Color3(
            ColorTable.getColor(colorIndex).r,
            ColorTable.getColor(colorIndex).g,
            ColorTable.getColor(colorIndex).b
          );
          colorIndex++;
        }
      } else {
        partSettings.visible = false;
        partSettings.opacity = 0;
      }
    }
  }

  public togglePartVisibility(modelId: number, partId: number, visibility: boolean) {
    for (let i = 0; i < this.c3Service._model[modelId.toString()].partCount; ++i) {
      let partSettings = this.c3Service._model[modelId.toString()].getPartSettingsAt(i);

      if (partSettings.partId === partId) {
        partSettings.visible = visibility;
      }
    }
    this.autoZoom(modelId);
  }

  public getColorAt(modelId: number, i: number) {
    let partSettings = this.c3Service._model[modelId.toString()].getPartSettingsAt(i);
    return partSettings.color;
  }

  public setCustomPartInfo(partsCustomInfo: PartsCustomInfo) {
    this.partsCustomInfo.push(partsCustomInfo);
  }

  public getCustomPartInfo() {
    return this.partsCustomInfo;
  }

  public removePartInfoAt(id: number) {
    for (let i = 0; i < this.partsCustomInfo.length; i++) {
      if (this.partsCustomInfo[i].partId == id) {
        this.partsCustomInfo.splice(i, 1);
      }
    }
  }

  public clearPartsCustomInfo() {
    this.partsCustomInfo = [];
  }

  public setType(name: string) {
    if (name.includes('inlet') || name.includes('jetInlet')) {
      return 'inlet';
    }

    if (name.includes('outlet')) {
      return 'outlet';
    }

    if (name.includes('wall')) {
      return 'wall';
    }

    return 'not found';
  }

  private autoZoom(modelId: number) {
    const view = this.c3Service._viewer[modelId.toString()].getViewAt(0);
    const boundingBox = view.getBoundingBox();
    this.c3Service._viewer[modelId.toString()].getViewAt(0).camera.zoomToBoundingBox(boundingBox);
  }
}
